import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonFr from "../locales/fr/common.json";
import commonEn from "../locales/en/common.json";
import commonAr from "../locales/ar/common.json";
import activiteFr from "../locales/fr/activite.json";
import activiteEn from "../locales/en/activite.json";
import activiteAr from "../locales/ar/activite.json";

// Languages supported by the backoffice. `fr` stays the fallback since the
// vast majority of the UI is still hardcoded French — only modules migrated
// to `t(...)` calls actually change with the selected language until the
// rest of the app is progressively extracted.
export const SUPPORTED_LANGUAGES = ["fr", "en", "ar"];
export const RTL_LANGUAGES = ["ar"];
export const DEFAULT_LANGUAGE = "fr";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: {common: commonFr, activite: activiteFr},
            en: {common: commonEn, activite: activiteEn},
            ar: {common: commonAr, activite: activiteAr},
        },
        supportedLngs: SUPPORTED_LANGUAGES,
        fallbackLng: DEFAULT_LANGUAGE,
        defaultNS: "common",
        ns: ["common", "activite"],
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            // Mirrors the darkMode preference pattern: localStorage first,
            // then fall back to the browser's language.
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "language",
            caches: ["localStorage"],
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
